'use strict';

var _Object$keys = require('babel-runtime/core-js/object/keys')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

Object.defineProperty(exports, '__esModule', {
    value: true
});
exports.getPropsFor = getPropsFor;
exports.filterPropsFor = filterPropsFor;
exports.filterPropsExcept = filterPropsExcept;

var _data = require('../data/');

var _data2 = _interopRequireDefault(_data);

function getPropsFor(tag) {
    return _Object$keys(_data2['default']).filter(function (propName) {
        return _data2['default'][propName].indexOf(tag) !== -1;
    });
}

function filterPropsFor(props, tag) {
    var propsForTag = getPropsFor(tag);

    return _Object$keys(props).reduce(function (obj, propName) {
        if (propsForTag.indexOf(propName) !== -1) {
            obj[propName] = props[propName];
        }

        return obj;
    }, {});
}

function filterPropsExcept(props, tag) {
    var propsForTag = getPropsFor(tag);

    return _Object$keys(props).reduce(function (obj, propName) {
        if (propsForTag.indexOf(propName) === -1) {
            obj[propName] = props[propName];
        }

        return obj;
    }, {});
}


//////////////////
// WEBPACK FOOTER
// ./~/react-attrs-filter/build/index.js
// module id = 1587
// module chunks = 0